module.exports = __webpack_public_path__ + "assets/img/img-fv-06.386878f0.png";